import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { RootState } from '../../store';
import { Container, Content } from './styles';
import BackArrow from '../../components/BackArrow';
import ChallengeCardList from '../../components/ChallengeCardList';

import { loginWithToken } from '../../store/Auth.store';
import { api2 } from '../../services/api';
import { ChallengeDetailType } from '../../types/Challenger';
import Loader from '../../components/Loader';

export default function Challenges() {
  const [searchParms] = useSearchParams();
  const dispatch = useDispatch();

  const token = searchParms.get('token');
  const err = searchParms.get('err');

  const _loginWithToken = async () => {
    if (err) {
      window.location.href = '/login';
      return;
    }
    if (token) {
      const data = JSON.parse(atob(token.split('.')[1]));
      await dispatch(loginWithToken(data.uid, token) as any);
    }
  };

  useEffect(() => {
    _loginWithToken();
  }, [token]);

  const navigate = useNavigate();
  const auth = useSelector((state: RootState) => state.auth);
  const { user } = auth;
  const { id, company_id, companies } = user;

  const [challenges, setChallenges] = useState<ChallengeDetailType[]>();
  const [loading, setLoading] = useState(false);

  const getChallenges = async () => {
    setLoading(true);
    api2.get('/challenge-detail')
      .then(((response) => {
        setChallenges(response.data);
      })).catch(() => {
        toast.error('Erro ao carregar os desafios virtuais');
      }).finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getChallenges();
  }, []);

  return (
    <Container>
      {id
        && (
          <BackArrow text="Desafios Virtuais" bigger backTo="/club/challenge-list" />
        )}
      <Content>
        {!loading && challenges?.map(({
          banner, medal, title, description, distance, slug, companyId, isCompanyChallenge, medalBanner,
        }, index) => (
          ((isCompanyChallenge && (company_id === companyId || companies?.some((company) => company.id === companyId))) || !isCompanyChallenge) && (
            <ChallengeCardList
              key={index}
              action={() => navigate(slug)}
              image={banner}
              medal={medal}
              title={title}
              info={description}
              distance={distance}
              medalBanner={medalBanner}
            />
          )
        ))}
        {loading && <Loader color="white" />}
      </Content>
    </Container>
  );
}
